import { request } from '@/api/client'
import type { UiSettingRow } from '@shared/uiSettings'

const base = '/ext/ui-settings'

export const uiSettingsService = {
  list: (signal?: AbortSignal) => request<UiSettingRow[]>(base, { signal }).then((r) => r.data),
  save: (key: string, row: Pick<UiSettingRow, 'kind' | 'visible' | 'required' | 'exceptions'>) =>
    request(`${base}/${encodeURIComponent(key)}`, { method: 'PUT', body: row }).then((r) => r.data),
  reset: (key: string) => request(`${base}/${encodeURIComponent(key)}`, { method: 'DELETE' }).then((r) => r.data),
}
